import React, { Component } from 'react';


const socialNetworkArray = [
  {
    name: "Twitter",
    purpose: "Follow me for the latest update",
    url: "https://twitter.com/arle13",
  },
  {
    name: "Medium",
    purpose: "Read my other stories",
    url: "https://medium.com/@arle13",

  },
  {
    name: "LinkedIn",
    purpose: "Business-ish connections",
    url: "https://www.linkedin.com/in/jinju-jang/",

  },
  {
    name: "Dribbble",
    purpose: "Show and tell the little bits",
    url: "https://dribbble.com/arle13",

  },
];

class Card extends Component{
  render(){
    return(
      <div className="social-wrap">
        {socialNetworkArray.map(item => (
          <div key={item.name} className="social-card">
            <a href={item.url} target="_blank">
              <div className="social-info">
                <span className="social-name">{item.name}</span>
                <span className="social-role">{item.purpose}</span>
              </div>
            </a>
          </div>
        ))}
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/layout/warp/Card.js